<template>
  <section class="payment">
    <h2>Select a secure payment</h2>

    <div class="payment__methods">
      <form v-for="method in methods" :key="method.name" :id="method.id" :class="['method', {method_active: method.name === activeMethod}]">
        <div class="method__title" @click="(e) => handlePaymentSelect(e, method.name)">
          <div class="method__name">
            <img v-show="method.name === activeMethod" src="/media/video-locator-lp-template-e/payment/radio_checked.svg" alt="radio checked">
            <img v-show="method.name !== activeMethod" src="/media/video-locator-lp-template-e/payment/radio.svg" alt="radio">

            <h3>{{method.name}}</h3>
          </div>

          <img :src="method.icon" :alt="method.name">
        </div>

        <div v-if="method.available" class="method__content">
          <div class="payment__total">
            <div class="total__row">
              <span>Monthly plan</span>
              <span class="plan__price">USD {{method.price.plan}}</span>
            </div>
            <div class="total__row row_footer">
              <div>
                <span class="text_big">Only today</span>
                <span>Total:</span>
              </div>
              <span>USD {{method.price.total}}</span>
            </div>
          </div>

          <div v-if="method.name === 'Credit Card'" class="plain-form">
            <label>
              <span>Name</span>
              <input v-model="userInfo.name" class="name" name="name" type="text" required>
            </label>

            <label>
              <span>Email</span>
              <input v-model="userInfo.email" class="email" name="email" type="email" required>
            </label>

            <label>
              <span>City</span>
              <input v-model="userInfo.city" class="address" name="city" type="text" required>
            </label>

            <label>
              <span>Address</span>
              <input v-model="userInfo.address" class="address" name="address" type="text" required>
            </label>

            <div class="stripe-input" id="card-form"></div>
          </div>

          <button>
            <template v-if="method.name === 'Credit Card'">Start Now!</template>
            <img v-else :src="method.icon" :alt="method.name">
          </button>
        </div>
        <div v-else class="method__content">
          <p>Sorry, payment method not available on this device</p>
        </div>
      </form>
    </div>

    <div class="payment__features">
      <div v-for="(feature, i) in features" :key="i" class="payment__feature">
        <img :src="feature.icon" alt="">

        <div class="payment-feature__content">
          <span>{{feature.title}}</span>
          <p v-html="feature.text"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { EventBus } from '../../EventBus';

export default {
  name: "PaymentModal",
  data() {
    return {
      loading: false,
      activeMethod: null,
      activePaymentElement: null,
      userInfo: {
        name: null,
        email: null,
        address: null,
        city: null,
      },
      features: [
        {
          icon: "/media/video-locator-lp-template-e/payment/cancel.svg",
          title: "Cancel anytime",
          text: "Contact our customer support at <a href='mailto:support@" + location.hostname + "'>support@" + location.hostname + "</a> to cancel your subscription",
        },
        {
          icon: "/media/video-locator-lp-template-e/payment/secure.svg",
          title: "See secure payment",
          text: "Your information is protected by the most advanced data encryption technology",
        },
        {
          icon: "/media/video-locator-lp-template-e/payment/payment-methods.svg",
          title: "Accepted payment methods",
          text: "ApplePay, Credit Cards",
        },
      ],
      methods: [
        {
          id: 'apple-pay-form',
          available: false,
          name: "ApplePay",
          icon: "/media/video-locator-lp-template-e/payment/apple-pay.png",
          price: {
            plan: "29.99",
            discount: "29.99",
            total: "0.00",
          },
        },
        {
          id: 'card-subscription-form',
          available: true,
          name: "Credit Card",
          icon: "/media/video-locator-lp-template-e/payment/visa-mastercard.png",
          price: {
            plan: "29.99",
            discount: "29.99",
            total: "0.00",
          },
        },
      ],
      verticalPadding: 24,
    };
  },

  methods: {
    handlePaymentSelect(event, method) {
      if (this.activeMethod === method) {
        return;
      }

      if (this.activePaymentElement) {
        this.activePaymentElement.style.maxHeight = null;
      }

      this.activeMethod = method;
    },

    toggleApplePay() {
      this.methods[0].available = true

      let form = document.querySelector('#apple-pay-form')

      form.addEventListener('submit', (event) => {
        event.preventDefault()

        if (this.loading) { return }

        if (this.paymentRequest) {
          this.tracker.report('show_payment_request')
          this.paymentRequest.show()
          this.loading = true
        } else {
          this.tracker.report('show_payment_request_error')
          alert('Something went wrong, please try again later')
        }
      })
    },

    completePayment(status, event, link) {
      event && event.complete(status)

      if (status == 'success') {
        EventBus.$emit('download-app', link)
      } else {
        EventBus.$emit('hide-preloader')
        alert('Something went wrong')
      }
    },

    init() {
      var cbInstance = Chargebee.init({
        site: this.session.info.chargebee.site,
        publishableKey: this.session.info.chargebee.publishable_key
      })
      let trialEnd = new Date()
      trialEnd.setDate(trialEnd.getDate() + 3)
      console.log('Trial end:', trialEnd)

      var paymentRequest = this.session.stripeAPI.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'PREMIUM VERSION',
          amount: 0,
        },
        requestPayerEmail: true,
        requestPayerName: true,
        disableWallets: [
          'link',
        ],
      });

      paymentRequest.canMakePayment().then((result) => {
        if (result) {
          this.paymentRequest = paymentRequest
          console.log('Cane make payments:', result)
          this.toggleApplePay()
        } else {
          console.log('Apple Pay support not found. Check the pre-requisites above and ensure you are testing in a supported browser.')
          this.tracker.report('can_make_payment_false')
        }

        // Initialize card form
        const form = document.querySelector('#card-subscription-form')
        console.log('Form:', form)

        initSetupForm(form, this.session.stripeAPI).then(() => {
          console.log('Stripe form initialized')
        })
      });

      paymentRequest.on('paymentmethod', async (e) => {
        var paymentMethod = e.paymentMethod
        console.log(e, paymentMethod)

        let formData = new FormData()
        formData.append('csrfmiddlewaretoken', this.session.info.csrf_token)
        formData.append('email', e.payerEmail)
        formData.append('payment_method', JSON.stringify(paymentMethod))

        EventBus.$emit('show-preloader')

        fetch('/api/subscription/update-payment-method/', {
          method: "POST",
          body: formData
        })
          .then(response => {
            if (response.status != 200) {
              throw new Error('Failed to create subscription')
            }
            return response.json()
          })
          .then(data => {
            return this.createChargebeeSubscription(
              `${data.customer}/${paymentMethod.id}`,
              e.payerEmail)
          })
          .then(is_ok => {
            this.completePayment(is_ok ? 'success' : 'fail', e)
          })
          .catch(error => {
            alert(error.displayMessage || error.message)
            this.completePayment('fail', e)
            return false
          })
      });

      paymentRequest.on('cancel', () => {
        this.loading = false
      })

      paymentRequest.on('error', () => {
        this.loading = false
      })
    },

    /**
     * Creates chargebee subscription via API
     * @param {String} stripe_customer Payment intent ID
     * @param {String} email Customer email address associated with subscription
     */
    createChargebeeSubscription(stripe_customer, email) {
      this.loading = true

      let formData = new FormData()
      formData.append('csrfmiddlewaretoken', this.session.info.csrf_token)
      formData.append('email', email)
      formData.append('stripe_customer', stripe_customer)
      formData.append('item_price', this.session.info.plan.id)

      let promise = fetch('/api/chargebee/subscribe-with-stripe/', {
        method: "POST",
        body: formData
      })
        .then((response) => {
          if (response.status != 200) {
            throw new Error('Failed to create subscription')
          }
          return response.json()
        })
        .then((data) => {
          this.tracker.report('start_trial')
          this.completePayment('success', event, data.install_url)
          return true
        })
        .catch(error => {
          // TODO: handle error
          alert(error.displayMessage || error.message)
          return false
        })

      return promise
    },

    updateUserInfo(userInfo) {
      console.log('[payment modal] update user info:', userInfo)

      if (userInfo) {
        this.userInfo.name = `${userInfo.first_name} ${userInfo.last_name}`
        this.userInfo.email = userInfo.email
        this.init()
      }
    }
  },

  computed: {
    session() {
      return this.$root.$children[0].$refs.session
    },
    tracker() {
      return this.$root.$children[0].$refs.tracker
    },
  },

  mounted() {
    console.log('Payment Modal mounted')

    if (window.ApplePaySession) {
      this.tracker.report('apple_pay_available')
    } else {
      this.tracker.report('apple_pay_not_available')
    }

    EventBus.$emit('get-user-info')
  },

  created() {
    EventBus.$on('user-info-saved', this.updateUserInfo)
    EventBus.$on('user-info', this.updateUserInfo)
  },

  destroyed() {
    EventBus.$off('user-info-saved', this.updateUserInfo)
    EventBus.$off('user-info', this.updateUserInfo)
  },
}
</script>

<style lang="sass">
.payment
  display: flex
  flex-direction: column
  max-width: 513px
  width: 100%
  padding: 40px 40px 80px
  background: rgba(255, 255, 255, 1)
  border-radius: 24px
  z-index: 1
  max-height: 90lvh
  overflow-y: scroll

  &::-webkit-scrollbar
    width: 0

  h2
    font-size: 1.125rem
    line-height: 1.5rem
    color: #000000
    font-weight: 500
    text-align: left

  .payment__methods
    margin: 24px 0 40px

    .plan__price
      text-decoration: line-through

    .method
      max-width: unset
      box-shadow: unset
      padding: 0
      border-radius: 8px
      border: 1px solid rgba(231, 231, 231, 1)
      background: rgba(255, 255, 255, 1)
      margin-bottom: 16px

      &.method_active
        .method__content
          padding: 12px
          height: fit-content
          max-height: 5000px

          p
            color: #e21212

      &:last-child
        margin-bottom: 0

    .plain-form
      label
        display: flex
        flex-direction: column
        align-items: flex-start
        margin-bottom: 16px

        input
          border: 1px solid rgba(175, 175, 175, 1)
          border-radius: 8px
          padding: 15px 10px
          font-size: 0.875rem
          line-height: 1.125rem
          color: rgba(42, 42, 42, 1)

        & > span
          color: rgba(42, 42, 42, 1)
          font-size: 0.875rem
          line-height: 1.125rem
          margin-bottom: 8px

        &.card-number
          .stripe-input
            width: 100%
            border: 1px solid rgba(175, 175, 175, 1)
            border-radius: 8px
            padding: 15px 10px
            margin-bottom: 0

          .expires
            display: flex
            margin-right: 16px

            span
              color: rgb(128, 128, 128)
              margin: 0 4px

          input
            border-radius: 0
            border: none
            background: none
            padding: 0
            outline: none

        &:last-child
          margin-bottom: 0

    .method__title
      display: flex
      align-items: center
      justify-content: space-between
      padding: 12px
      height: 48px
      cursor: pointer

    .method__name
      display: flex
      align-items: center

      h3
        font-size: 1rem
        line-height: 1.25rem
        color: #000000
        font-weight: 400
        margin-left: 12px

    .method__content
      padding: 0 12px
      height: 0
      max-height: 0
      overflow: hidden
      transition: 0.5s ease-out

      button
        display: flex
        justify-content: center
        align-items: center
        height: 48px
        width: 100%
        border: none
        outline: none
        border-radius: 8px
        background: rgba(246, 198, 87, 1)
        font-size: 1.25rem
        line-height: 1.75rem
        color: rgba(0, 0, 0, 1)
        font-weight: 700
        cursor: pointer
        margin-top: 32px

    .payment__total
      margin-bottom: 28px

      .total__row
        display: flex
        justify-content: space-between
        font-size: 0.875rem
        line-height: 1.125rem
        color: rgba(42, 42, 42, 1)
        margin-bottom: 8px

        span
          color: #2a2a2a

        &.row_discount
          font-weight: 700

          span
            text-align: left
            color: rgba(238, 124, 78, 1)
            display: flex
            flex-diraction: column
            align-items: flex-end

        &.row_footer
          display: flex
          align-items: center
          justify-content: space-between
          font-weight: 700
          margin-top: 24px
          margin-bottom: 0
          background: rgba(255, 246, 229, 1)
          border-radius: 8px
          padding: 10px 10px 10px 20px

          & > span
            font-size: 22px
            line-height: 28px

          div
            display: flex
            flex-direction: column
            align-items: flex-start
            gap: 4px

            .text_big
              font-size: 1.25rem
              line-height: 1.75rem
              font-weight: 700
              text-transform: uppercase
              color: rgba(0, 52, 92, 1)

          span
            color: rgba(0, 0, 0, 1)

  .payment__features
    display: flex
    flex-direction: column

  .payment__feature
    display: flex
    align-items: center
    margin-bottom: 16px

    .payment-feature__content
      display: flex
      flex-direction: column
      align-items: flex-start

    span
      text-align: left
      font-size: 1rem
      line-height: 1.25rem
      color: rgba(42, 42, 42, 1)
      font-weight: 700
      margin-bottom: 6px

    p
      text-align: left
      font-size: 0.725rem
      line-height: 1.25rem
      font-weight: 400
      color: #000000

      a
        color: blue

    &:last-child
      margin-bottom: 0

    img
      margin-right: 16px
</style>
